<template>
	<div>
		<div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="6">
			<div class="columns is-multiline is-centered" v-lazy-container="{ selector: 'img' }" ref="videoGallery">
				<div class="column" :class="width" v-for="(video , index) in videos" :key="`video${index}`">
					<div class="card card-article">
						<a :href="video.link" class="lightselect" data-sub-html=".caption">
							<div class="card-image">
								<div class="video-container">
									<iframe width="640" height="360" :src="video.link" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
								</div>
								<div class="caption" style="display: none;">
									<h4>
										{{video.description}}
									</h4>
								</div>
								<div class="card-content is-overlay has-text-centered">
									<div class="mx-auto play is-inline-block mt-7"><img data-src="/front/img/illustrations/play.svg" alt=""></div>
								</div>
							</div>

							<div class="card-content">
								<div class="content has-text-weight-bold">
									<p class="truncate-3-lines has-text-primary">
										{{video.description}}
									</p>
									<time class="has-text-secondary has-text-left is-block" datetime="2020-8-22">{{video.date}}</time>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
			<div class="mt-6 has-text-centered content-loader-container" v-show="loadMore">
				<img src="/front/img/illustrations/content_loader.svg" class="content-loader"  alt="">
			</div>
		</div>
	</div>
</template>


<script>
import axios from 'axios';
import infiniteScroll from 'vue-infinite-scroll';


export default {
	name: "Videos",
	directives: {
		infiniteScroll
	},
	props: {
		lang:{
			type: String,
			required: true
		},
		url: String,
		width:{
			type:String,
			default: 'is-4'
		},
		withFilter:{
			type:Boolean,
			default: true
		}
	},
	computed: {
		busy() {
			return this.fetching
		}
	},
	data(){
		return {
			currentPage: 0,
			fetching: true,
			loadMore : true,
			nextUrl : String,
			videos: [],
		};
	},
	created() {
		this.nextUrl = this.url;
		this.videos = [];
		this.loadNextPage();
	},
	mounted() {
		this.$translate.setLang(this.lang);
		this.initiateGallery(this.$refs.videoGallery);
	},
	methods: {
		loadNextPage() {
			this.currentPage++;
			this.fetching = true;
			if(this.nextUrl != null){
				axios.get(this.nextUrl)
				.then(({ data }) => {
					this.videos.push(...data.data);
					if(data.links.next != null) {
						this.nextUrl = data.links.next;
					} else {
						this.nextUrl = data.links.next;
					}
					this.fetching = false;
					setTimeout(() => {
						this.destroyGallery(this.$refs.videoGallery);
						this.initiateGallery(this.$refs.videoGallery);
					}, 50);
				});
			}
			else{
				this.loadMore = false;
			}
		},
		initiateGallery(gallery){
			lightGallery(gallery, {
				selector:'.lightselect',
				subHtmlSelectorRelative: true,
				showAfterLoad:true
			});
		},
		destroyGallery(gallery){
			window.lgData[gallery.getAttribute('lg-uid')].destroy(true);
		}
	},
}
</script>

<style scoped lang="scss">

.video-container {
  position: relative;
  padding-bottom: 56.25%; /*16:9*/
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
